<template>
    <div class="popShare" v-if="isActive" :class="isShow && `show`">
        <div class="popShare-content">
            <div class="popShare-main">

                <div class="popShare-header">
                    <h2 class="popShare-headerText">{{ `แชร์ลิงก์` }}</h2>
                    <button tabindex="-1" type="button" class="popShare-buttonClose" @click="close"><span
                            class="material-symbols-outlined">close</span></button>
                </div>

                <div class="popShare-body">
                    <input ref="input" readonly="readonly" type="text" class="form-control" v-model="value"
                        @click="focusInput" />

                    <div class="social-list">
                        <button type="button" @click="clickHandle(item.id)" class="social-item"
                            v-for="(item, index) in socialList" :key="index">
                            <div class="social-icon" v-html="item.svg"></div>
                            <p class="social-text">{{ item.name }}</p>
                        </button>

                        <ShareNetwork class="social-item" v-for="item in socialPluginList" :key="item.id"
                            :network="item.id" :url="meta.url" :title="meta.title" :description="meta.description">
                            <div class="social-icon" v-html="item.svg"></div>
                            <p class="social-text">{{ item.name }}</p>
                        </ShareNetwork>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
export default {
    props: ['url'],
    name: 'PopShare',

    computed: {
        isPopShare() {
            return this.$store.getters.popShare
        },
    },
    watch: {
        isPopShare(val) {
            if (val) {
                this.showHandle()
            }
            else {
                this.hideHandle()
            }
        },
    },
    data() {
        const socialList = []
        const socialPluginList = []

        socialPluginList.push({ name: `LINE`, svg: `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><g><g><g><g transform="translate(-656 -254) translate(272 102) translate(0 80) translate(372 60) translate(12 12)"><circle cx="20" cy="20" r="20" fill="#22BA4F"></circle><path fill="#FFF" d="M33.338 18.835C33.338 12.861 27.35 8 19.988 8 12.624 8 6.634 12.861 6.634 18.835c0 5.356 4.75 9.841 11.166 10.69.435.094 1.026.287 1.176.658.135.337.088.866.043 1.208 0 0-.16.942-.19 1.142-.059.338-.268 1.32 1.157.72 1.425-.6 7.689-4.527 10.49-7.751 1.934-2.122 2.861-4.276 2.861-6.667z"></path><path fill="#22BA4F" d="M28.896 17.404c.141 0 .256-.114.256-.255v-.947c-.001-.14-.115-.254-.256-.255h-3.75c-.068 0-.133.027-.181.075-.048.048-.075.113-.075.18v5.816c0 .14.114.255.255.255h3.751c.141 0 .256-.114.256-.255v-.947c-.001-.14-.115-.254-.256-.255h-2.55v-.983h2.549c.14 0 .255-.114.255-.255v-.947c0-.14-.115-.254-.255-.255h-2.55v-.983l2.551.011zM15.02 20.827h-2.55v-4.625c0-.14-.113-.254-.253-.255h-.948c-.14 0-.254.115-.254.255v5.822c0 .14.114.255.254.256h3.751c.141 0 .256-.115.256-.256v-.946c-.003-.14-.117-.25-.256-.25z"></path><rect width="1.457" height="6.337" x="16.077" y="15.949" fill="#22BA4F" rx=".255"></rect><path fill="#22BA4F" d="M23.725 15.949h-.947c-.14 0-.254.113-.254.253v3.462l-2.667-3.6c-.006-.01-.013-.019-.02-.027l-.015-.016-.015-.011-.013-.01H18.7c-.14 0-.254.114-.254.254v5.828c0 .14.114.254.254.254h.948c.14 0 .253-.114.253-.254V18.57l2.67 3.599c.019.024.041.046.066.064l.016.01H22.704c.022.005.044.007.067.008h.941c.14 0 .255-.114.256-.254v-5.795c0-.135-.107-.247-.243-.253z"></path></g></g></g></g></g></g></svg>`, id: `line` })
        socialPluginList.push({ name: `Facebook`, svg: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40" height="40" viewBox="0 0 40 40"><defs><path id="69sb1r4v1a" d="M0.002 0.002L40 0.002 40 39.757 0.002 39.757z"></path></defs><g fill="none" fill-rule="evenodd"><g><g><g><g><g><g><g transform="translate(-744 -254) translate(272 102) translate(0 80) translate(372 60) translate(88) translate(12 12)"><mask id="6bpksqptfb" fill="#fff"><use xlink:href="#69sb1r4v1a"></use></mask><path fill="#1877F2" d="M40 20C40 8.954 31.046 0 20 0S0 8.954 0 20c0 9.983 7.314 18.257 16.875 19.757V25.781h-5.078V20h5.078v-4.406c0-5.013 2.986-7.781 7.554-7.781 2.188 0 4.477.39 4.477.39v4.922h-2.522c-2.484 0-3.259 1.542-3.259 3.123V20h5.547l-.887 5.781h-4.66v13.976C32.686 38.257 40 29.983 40 20" mask="url(#6bpksqptfb)"></path></g><path fill="#FFF" d="M27.785 25.781L28.672 20h-5.547v-3.752c0-1.581.775-3.123 3.26-3.123h2.521V8.203s-2.289-.39-4.477-.39c-4.568 0-7.554 2.768-7.554 7.78V20h-5.078v5.781h5.078v13.976c1.018.16 2.062.243 3.125.243 1.063 0 2.107-.083 3.125-.243V25.781h4.66" transform="translate(-744 -254) translate(272 102) translate(0 80) translate(372 60) translate(88) translate(12 12)"></path></g></g></g></g></g></g></g></svg>`, id: `facebook` })
        socialPluginList.push({ name: `Twitter`, svg: `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><g><g><g><g><g><g fill="#1DA1F2" transform="translate(-832 -254) translate(272 102) translate(0 80) translate(372 60) translate(176) translate(12 12)"><circle cx="20" cy="20" r="20"></circle></g><g fill="#FFF"><path d="M7.44 19.15c8.87 0 13.72-7.35 13.72-13.72 0-.21 0-.42-.01-.62.94-.68 1.76-1.53 2.41-2.5-.86.38-1.79.64-2.77.76 1-.6 1.76-1.54 2.12-2.67-.93.55-1.96.95-3.06 1.17C18.97.63 17.72.05 16.33.05c-2.66 0-4.82 2.16-4.82 4.82 0 .38.04.75.13 1.1C7.63 5.77 4.08 3.85 1.7.93c-.41.71-.65 1.54-.65 2.42 0 1.67.85 3.15 2.15 4.01-.79-.02-1.53-.24-2.18-.6v.06c0 2.34 1.66 4.28 3.87 4.73-.4.11-.83.17-1.27.17-.31 0-.61-.03-.91-.09.61 1.92 2.39 3.31 4.5 3.35-1.65 1.29-3.73 2.06-5.99 2.06-.39 0-.77-.02-1.15-.07 2.11 1.38 4.65 2.18 7.37 2.18" transform="translate(-832 -254) translate(272 102) translate(0 80) translate(372 60) translate(176) translate(12 12) translate(8.9 11.4)"></path></g></g></g></g></g></g></g></g></svg>`, id: `twitter` })

        socialList.push({ name: `คัดลอกลิงก์`, svg: `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><g fill="none" fill-rule="evenodd"><g><g><g><g><g><g transform="translate(-920 -254) translate(272 102) translate(0 80) translate(372 60) translate(264) translate(12 12)"><rect width="40" height="40" fill="#E9EAEC" rx="20"></rect><g fill="#515A6C"><path d="M13.094 15.578c.243-.412.106-.944-.306-1.187-.242-.143-.466-.317-.667-.516-1.305-1.304-1.305-3.428 0-4.732l3.724-3.725c1.306-1.303 3.428-1.3 4.732 0 1.304 1.305 1.304 3.428 0 4.732l-2.98 2.98c-.337.339-.337.887 0 1.225.34.339.888.339 1.226 0l2.98-2.98c1.98-1.98 1.98-5.201 0-7.182-1.98-1.98-5.2-1.98-7.183 0l-3.724 3.725c-1.98 1.98-1.98 5.2 0 7.182.303.304.643.567 1.01.785.138.08.291.12.44.12.298 0 .587-.153.748-.427m-5.308 7.709c-1.302 0-2.602-.495-3.592-1.485-1.98-1.98-1.98-5.202 0-7.183l2.979-2.979c.339-.338.887-.338 1.225 0 .34.34.34.887 0 1.225l-2.98 2.98c-1.304 1.304-1.304 3.427 0 4.731 1.305 1.304 3.426 1.305 4.733 0l3.724-3.723c1.305-1.304 1.305-3.428 0-4.732-.201-.2-.425-.374-.667-.517-.412-.243-.548-.775-.307-1.187.243-.413.776-.55 1.188-.307.368.218.707.481 1.012.786 1.98 1.98 1.98 5.2 0 7.182l-3.725 3.724c-.99.99-2.29 1.485-3.59 1.485" transform="translate(7 7)"></path></g></g></g></g></g></g></g></g></svg>`, id: `copyLink` })

        return {
            socialList,
            socialPluginList,
            isActive: false,
            isShow: false,

            value: window.location.href,

            meta: {
                url: ``,
                title: ``,
                description: ``,
                quote: ``,
                hashtags: ``,

                twitterUser: ``,
            },


        }
    },

    mounted() {
        this.value = this.url
        this.meta.url = this.url

        // set data

        const title = this.getMeta('title');
        // const url = this.getMeta('og:url');
        const description = this.getMeta('description');

        this.meta.title = title
        this.meta.description = description
        // console.log(title, url, description);
        // 
        // property="og:url"
    },

    methods: {
        close() {
            this.$store.dispatch('popShare', false)
        },

        showHandle() {
            this.isActive = true
        },

        hideHandle() {
            this.isActive = false
        },

        focusInput() {
            this.$refs.input.select()
        },

        clickHandle(evt) {
            if (evt == 'copyLink') {
                this.copyTextToClipboard()
            }
        },

        shareToLINE() {

            this.VueSweetalert2
        },

        copyTextToClipboard() {
            // Get the text field
            var copyText = this.$refs.input;

            // Select the text field
            copyText.select();
            copyText.setSelectionRange(0, 99999); // For mobile devices

            navigator.clipboard.writeText(copyText.value);

            this.$swal({
                icon: `success`,
                text: `คัดลอกลิงก์สำเร็จ`,
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
            });
        },

        getMeta(metaName) {
            const metas = document.getElementsByTagName('meta');

            for (let i = 0; i < metas.length; i++) {
                if (metas[i].getAttribute('name') === metaName) {
                    return metas[i].getAttribute('content');
                }
            }

            return '';
        }
    }
}
</script>

<style lang="scss" scoped>
.social-list {
    margin-top: 15px;
    display: flex;
    gap: 5px;
    flex-wrap: wrap;
}

.popShare {
    display: flex;
    position: fixed;

    z-index: 400;
    flex-direction: unset;
    inset: 0px;
    background-color: rgba(0, 0, 0, 0.5);

}

.popShare-content {
    box-sizing: border-box;

    box-shadow: rgb(20 21 26 / 16%) 0px 8px 16px, rgb(71 77 87 / 16%) 0px 16px 32px, rgb(20 21 26 / 10%) 0px 0px 1px;
    background-color: #fff;

    // transform: translateY(-100%);
    animation: 0.3s ease-in-out 0s 1 normal none running animation-up;
    width: 100%;


    position: absolute;
    height: 50vh;
    bottom: 0;
    left: 0;
}

.popShare-main {
    display: flex;
    flex-direction: column;
}

@keyframes animation-popShareContent {
    0% {
        transform: scale(0.95);
    }

    66% {
        transform: scale(1.05);
    }

    100% {
        transform: scale(1);
    }
}

@keyframes animation-up {
    0% {
        transform: translateY(100%)
    }

    66% {
        transform: translateY(-1%)
    }

    100% {
        transform: translateY(0)
    }
}


.popShare-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 12px 12px 8px 24px;
    border-bottom: 1px solid #ddd;
}

.popShare-headerText {
    margin-bottom: 0;
    font-size: 32px;
}

.popShare-buttonClose {
    width: 38px;
    height: 38px;

    background-color: transparent;
    border: none;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background-color: #f2f2f2;
    }
}

.popShare-body {
    padding: 24px;

    .form-control {
        border-radius: 0;
        border-width: 0;
        box-shadow: none;
    }
}

.social-item {
    background-color: transparent;
    border: none;
    padding: 0;

    display: flex;
    flex-direction: column;
    gap: 6px;
    justify-content: center;
    align-items: center;
    padding: 10px;

    min-width: 80px;

    text-decoration: none;
    color: #000;

    .social-icon {
        display: flex;
        justify-content: center;
        align-items: center;

        width: 40px;
        height: 40px;
    }

    .social-text {
        font-size: 15px;
        line-height: 15px;
        margin: 0;
    }

    &:hover {
        background-color: #f2f2f2;
    }
}

@media (min-width: 600px) {
    .popShare {
        align-items: center;
        justify-content: center;
    }

    .popShare-content {
        animation: 0.3s ease-in-out 0s 1 normal none running animation-popShareContent;
        height: auto;
        transform: translateY(0);

        position: relative;
        bottom: auto;
        left: auto;
        max-width: 390px;
    }
}
</style>